import React from "react";
import { deviceDetect, isAndroid, isElectron, isIOS, isIOS13 } from "react-device-detect";

export const APPVERSION = '4.2.0';
export const APPID = 'org.auanet.coremobile';
export const APPYEAR = () => {
    let _d = new Date();
    let r = _d.getFullYear();

    return r;
}

export const TEMP_FEATURED = [
    {
        text:'Testis Meoplasms',
        secondary: 'oncology - Adult',
        updated_dt: '',
        path:'/corecontent',
        data: {
            id: 67
        },
        active: 1
    }, {
        text:'Testis Meoplasms',
        secondary: 'oncology - Adult',
        updated_dt: '',
        path:'/corecontent',
        data: {
            id: 67
        },
        active: 1
    }, {
        text:'Testis Meoplasms',
        secondary: 'oncology - Adult',
        updated_dt: '',
        path:'/corecontent',
        data: {
            id: 67
        },
        active: 1
    }
]

export const TEMP_NULL = null;
export const TEMP_EMPTY_ARRAY = [];
export const BACKGROUND_COLOR_MAIN = '#092640';
export const AISAPPID = '6B45923YSJ';
export const AISKEY = 'e22848162b86e1fae9e653fa49f153bc';
export const AISINDEX = [
    'aua_core_sections', 
    'aua_core_videos', 
    'aua_core_presentations'
];


export const TEMP_HOME_LIST = [
    {
        text:'My Cources',
        path:'/courses',
        icon:'CoursesIcon',
        active: 1
    }, {
        text:'My Transcripts',
        path:'/transcripts',
        icon:'TranscriptsIcon',
        active: 1
    }, {
        text:'Core Curriculum',
        path:'/core',
        icon:'CoreCurriculumIcon',
        active: 1
    }, {
        text:'Core Curriculum Videos',
        path:'/corevideos',
        icon:'CoreCurriculumVideosIcon',
        active: 1
    // }, {
    //     text:'Bookmarks',
    //     path:'/bookmarks',
    //     icon:'BookMarksIcon',
    //     active: 1
    }, {
        text:'Podcasts',
        path:'/podcasts',
        icon:'PodCastsIcon',
        active: 1
    }, {
        text:'Guidelines',
        path:'/guidelines',
        icon:'GuideLinesIcon',
        active: 1
    }, {
        text:'Update Series',
        path:'/updateseries',
        icon:'UpdateSeriesIcon',
        active: 1
    }, {
        text:'Testing Search',
        path:'/testsearch',
        icon:'UpdateSeriesIcon',
        active: 1
    }
];

export const DEVICECLASS = () => {
    // console.log(deviceDetect());
    if (isIOS13) {
        return "device-ios13";
    } else if (isIOS) {
        return "device-ios";
    } else if (isAndroid) {
        return "device-android";
    } else if (isElectron) {
        return "device-electron";
    } else {
        return "";
    }
}